__turbopack_context__.v({
  "Text": "index-module__MMMXaG__Text",
});
